import Utility from '../../../util/utilityfunctions';
import {TaskCategory} from '../../../util/uiconstants';
import {formatAssertionsForDisplayTaskWcgw} from '../../../reducers/WCGW/wcgwreducer';
import {sortBy} from 'lodash';
import {labels} from '../../../util/utils';
export const getTaskRelatedObjectsData = (taskRelateObjectsData) => {
	let data = {
		assertionAccounts: [],
		scots: []
	};

	if (!taskRelateObjectsData) {
		return data;
	}
	let taskRelateObjects = _.cloneDeep(taskRelateObjectsData);
	taskRelateObjects.assertions = taskRelateObjects && taskRelateObjects.assertions;
	data.assertionRisks = taskRelateObjects && taskRelateObjects.assertionRisks;
	data.assertions = taskRelateObjects && taskRelateObjects.assertions;
	if (taskRelateObjects && taskRelateObjects.assertions && taskRelateObjects.assertions.length > 0) {
		let account = {};
		account.accountName = taskRelateObjects.assertions[0].accountName;
		_.map(taskRelateObjects.assertions, (assertion) => {
			let risks = _.chain(assertion.assertionRisks)
				.groupBy('riskTypeId')
				.map((value, key) => {
					return value[0];
				})
				.value();

			assertion.assertionRisks = risks;
		});

		account.assertions = taskRelateObjects.assertions;
		data.assertionAccounts.push(account);
	}
	if (taskRelateObjects && taskRelateObjects.scots && taskRelateObjects.scots.length > 0) {
		data.scots = taskRelateObjects.scots;
	}
	if (taskRelateObjects && taskRelateObjects.controls && taskRelateObjects.controls.length > 0) {
		data.controls = taskRelateObjects.controls;
	}

	if (taskRelateObjects && taskRelateObjects.itProcesses && taskRelateObjects.itProcesses.length > 0) {
		data.itProcesses = taskRelateObjects.itProcesses;
	}

	if (taskRelateObjects && taskRelateObjects.wcgwScots && taskRelateObjects.wcgwScots.length > 0) {
		let wScots = _.cloneDeep(taskRelateObjects.wcgwScots);
		let wcgwScotsData = [];
		var formatedScotsData = wScots.reduce(function(res, value) {
			if (!res[value.scotId]) {
				res[value.scotId] = {
					scotId: value.scotId,
					scotName: value.scotName,
					wcgws: _.filter(wScots, (ws) => {
						return ws.scotId == value.scotId;
					})
				};
				wcgwScotsData.push(res[value.scotId]);
			}
			return res;
		}, {});
		data.wcgwScots = wcgwScotsData;
	}

	if (
		taskRelateObjects &&
		taskRelateObjects.itProcessesWithITControl &&
		taskRelateObjects.itProcessesWithITControl.length > 0
	) {
		let itProcessData = [];
		let itProcessControls = taskRelateObjects && _.cloneDeep(taskRelateObjects.itProcessesWithITControl);

		itProcessData = _.map(itProcessControls, (process) => {
			return {
				...process,
				itControls:
					taskRelateObjects.itProcesses.length === 0
						? process.itControls.filter((x) => x.hasITControlTesting)
						: process.itControls
			};
		});

		data.itprocessesControls = itProcessData.filter((process) => {
			return process.itControls.length > 0;
		});
	}

	if (taskRelateObjects && taskRelateObjects.scotsControls && taskRelateObjects.scotsControls.length > 0) {
		let scots = [];
		let groupedData = _.chain(taskRelateObjects.scotsControls)
			.groupBy('scotName')
			.map((value, key) => {
				let scot = {
					scotId: value[0].scotId,
					scotName: value[0].scotName,
					controls: value
				};
				scot.controls = value.sort(function(a, b) {
					return a.controlName.localeCompare(b.controlName);
				});
				scots.push(scot);
			})
			.value();

		let relatedControlsId = _.map(taskRelateObjects.scotsControls, ({controlId}) => {
			return controlId;
		});

		if (taskRelateObjects && taskRelateObjects.controls && taskRelateObjects.controls.length > 0) {
			let unrelatedControls = taskRelateObjects.controls.filter((conrol) => {
				return !relatedControlsId.includes(conrol.controlId);
			});

			if (unrelatedControls.length > 0) {
				unrelatedControls = unrelatedControls.sort(function(a, b) {
					return a.controlName.localeCompare(b.controlName);
				});
				let scot = {
					scotId: 0,
					scotName: labels.unrelatedControls,
					controls: unrelatedControls
				};

				scots.push(scot);
			}
		}
		data.scotsControls = scots;
	}
	return data;
};

export const getTaskRelatedObjects = (taskRelateObjects, taskRelatedItem, engagementITProcesses) => {
	let taskRelateObjectsData =
		taskRelateObjects &&
		taskRelateObjects.taskRelatedObjectData &&
		_.cloneDeep(taskRelateObjects.taskRelatedObjectData);

	if (!taskRelateObjectsData) {
		return taskRelateObjectsData;
	}

	let taskRelatedComponentItem = _.cloneDeep(taskRelatedItem);
	if (
		taskRelateObjectsData &&
		taskRelatedComponentItem &&
		taskRelatedComponentItem.components &&
		taskRelatedComponentItem.components.relatedTasks &&
		taskRelatedComponentItem.components.relatedTasks.length > 0
	) {
		taskRelateObjectsData.relatedTasks = taskRelatedComponentItem.components.relatedTasks;
	}
	if (
		taskRelateObjectsData &&
		taskRelatedItem &&
		taskRelatedItem.components &&
		taskRelatedItem.components.clientRequests &&
		taskRelatedComponentItem.components.externalTasks
	) {
		taskRelateObjectsData.collaboration = [
			...taskRelatedComponentItem.components.externalTasks,
			...taskRelatedComponentItem.components.clientRequests
		];
	}

	if (engagementITProcesses && engagementITProcesses.length > 0) {
		let itProcessData = [];
		let itControlsId = [];
		if (taskRelateObjects && taskRelateObjects.itControls && taskRelateObjects.itControls.length > 0) {
			itControlsId = _.map(taskRelateObjects.itControls, ({itControlId}) => {
				return itControlId;
			});
		}

		let itProcesses = _.cloneDeep(engagementITProcesses);

		_.map(itProcesses, (itProcess) => {
			let itptocessControls = itProcess.itControls.filter((conrol) => {
				return itControlsId.includes(conrol.id);
			});

			let itProcessControlsId = _.map(itptocessControls, ({id}) => {
				return id;
			});

			itProcess.itControls = taskRelateObjects.itControls.filter((conrol) => {
				return itProcessControlsId.includes(conrol.itControlId);
			});

			if (itProcess.itControls.length > 0) {
				itProcessData.push(itProcess);
			}
		});

		taskRelateObjectsData.itprocesses = itProcessData;
	}

	return taskRelateObjectsData;
};

export const getTaskRelatedComponent = (taskRelatedItem, payload) => {
	let data = {
		assertionAccounts: [],
		scots: [],
		accounts: []
	};

	let taskRelateObjects = _.cloneDeep(taskRelatedItem.components);
	taskRelateObjects.assertions = taskRelateObjects && taskRelateObjects.assertions;
	data.assertionRisks = taskRelateObjects && taskRelateObjects.assertionRisks;
	data.assertions = taskRelateObjects && taskRelateObjects.assertions;
	data.accounts = taskRelateObjects && taskRelateObjects.accounts;
	// if(taskRelateObjects && taskRelateObjects.accounts && taskRelateObjects.accounts.length > 0 ){
	// 	let account = {};

	// 	_.map(taskRelateObjects.accounts, (account) => {
	// 		account.accountName = taskRelateObjects.assertions[0].accountName;
	// 	})

	// 	account.assertions = taskRelateObjects.assertions;
	// 	data.assertionAccounts.push(account);
	// }

	if (taskRelateObjects && taskRelateObjects.assertions && taskRelateObjects.assertions.length > 0) {
		let account = {};
		account.accountName = taskRelateObjects.assertions[0].accountName;
		_.map(taskRelateObjects.assertions, (assertion) => {
			let risks = _.chain(assertion.assertionRisks)
				.groupBy('riskTypeId')
				.map((value, key) => {
					return value[0];
				})
				.value();

			assertion.assertionRisks = risks;
		});

		account.assertions = taskRelateObjects.assertions;
		data.assertionAccounts.push(account);
	}
	if (taskRelateObjects && taskRelateObjects.scots && taskRelateObjects.scots.length > 0) {
		data.scots = taskRelateObjects.scots;
	}
	if (taskRelateObjects && taskRelateObjects.controls && taskRelateObjects.controls.length > 0) {
		data.controls = taskRelateObjects.controls;
	}

	if (taskRelateObjects && taskRelateObjects.itProcesses && taskRelateObjects.itProcesses.length > 0) {
		data.itProcesses = taskRelateObjects.itProcesses;
	}

	if (
		payload.hasSubstantiveEvaluationMatrix &&
		taskRelateObjects &&
		taskRelateObjects.wcgwScots &&
		taskRelateObjects.wcgwScots.length > 0
	) {
		let wScots = _.cloneDeep(taskRelateObjects.wcgwScots);
		let wcgwScotsData = [];
		var formatedScotsData = wScots.reduce(function(res, value) {
			if (!res[value.scotId]) {
				res[value.scotId] = {
					scotId: value.scotId,
					scotName: value.scotName,
					wcgws: _.filter(wScots, (ws) => {
						return ws.scotId == value.scotId;
					})
				};
				wcgwScotsData.push(res[value.scotId]);
			}
			return res;
		}, {});
		data.wcgwScots = wcgwScotsData;
	}

	if (
		taskRelateObjects &&
		taskRelateObjects.itProcessesWithITControl &&
		taskRelateObjects.itProcessesWithITControl.length > 0
	) {
		let itProcessData = [];
		let itProcessControls = taskRelateObjects && _.cloneDeep(taskRelateObjects.itProcessesWithITControl);

		itProcessData = _.map(itProcessControls, (process) => {
			return {
				...process,
				itControls:
					taskRelateObjects.itProcesses.length === 0
						? process.itControls.filter((x) => x.hasITControlTesting)
						: process.itControls
			};
		});

		data.itprocessesControls = itProcessData.filter((process) => {
			return process.itControls.length > 0;
		});
	}

	if (taskRelateObjects && taskRelateObjects.scotsControls && taskRelateObjects.scotsControls.length > 0) {
		let scots = [];
		let groupedData = _.chain(taskRelateObjects.scotsControls)
			.groupBy('scotName')
			.map((value, key) => {
				let scot = {
					scotId: value[0].scotId,
					scotName: value[0].scotName,
					controls: value
				};
				scot.controls = value.sort(function(a, b) {
					return a.controlName.localeCompare(b.controlName);
				});
				scots.push(scot);
			})
			.value();

		let relatedControlsId = _.map(taskRelateObjects.scotsControls, ({controlId}) => {
			return controlId;
		});

		if (taskRelateObjects && taskRelateObjects.controls && taskRelateObjects.controls.length > 0) {
			let unrelatedControls = taskRelateObjects.controls.filter((conrol) => {
				return !relatedControlsId.includes(conrol.controlId);
			});

			if (unrelatedControls.length > 0) {
				unrelatedControls = unrelatedControls.sort(function(a, b) {
					return a.controlName.localeCompare(b.controlName);
				});
				let scot = {
					scotId: 0,
					scotName: labels.unrelatedControls,
					controls: unrelatedControls
				};

				scots.push(scot);
			}
		}
		data.scotsControls = scots;
	}

	if (taskRelateObjects && taskRelateObjects.relatedTasks && taskRelateObjects.relatedTasks.length > 0) {
		data.relatedTasks = taskRelateObjects.relatedTasks;
	}
	if (taskRelateObjects && taskRelateObjects.clientRequests && taskRelateObjects.externalTasks) {
		data.collaboration = [...taskRelateObjects.externalTasks, ...taskRelateObjects.clientRequests];
	}

	return data;
};
